import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirInvitationMarketplace() {
  return {
    loading: true,
    saving: false,
    analytics: null,
    settings: { creator_share_percent: 70, platform_share_percent: 30 },
    reviews: [],
    reviewFilter: 'pending',

    init() {
      this.loadAll();
    },

    async loadAll() {
      this.loading = true;
      try {
        const [analyticsRes, settingsRes, reviewsRes] = await Promise.all([
          axios.get('/api/v1/kasir/engagement/invitation-marketplace/analytics'),
          axios.get('/api/v1/kasir/engagement/invitation-marketplace/settings'),
          axios.get('/api/v1/kasir/engagement/invitation-reviews', { params: { status: this.reviewFilter } }),
        ]);
        this.analytics = analyticsRes.data.data || null;
        this.settings = settingsRes.data.data || this.settings;
        this.reviews = reviewsRes.data.data || [];
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat data marketplace.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async saveSettings() {
      this.saving = true;
      try {
        const { data } = await axios.put('/api/v1/kasir/engagement/invitation-marketplace/settings', this.settings);
        this.settings = data.data || this.settings;
        window.toast?.(data.message || 'Pengaturan disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan pengaturan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async filterReviews(status) {
      this.reviewFilter = status;
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/invitation-reviews', { params: { status } });
        this.reviews = data.data || [];
      } catch (e) {
        window.toast?.('Gagal memuat ulasan.', 'error');
      }
    },

    async moderateReview(id, status) {
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/invitation-reviews/${id}/moderate`, { status });
        window.toast?.(data.message || 'Ulasan diperbarui.', 'success');
        await this.filterReviews(this.reviewFilter);
        await this.loadAll();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal moderasi ulasan.', 'error');
      }
    },

    formatRp(n) {
      return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
    },
  };
}

Alpine.data('kasirInvitationMarketplace', createKasirInvitationMarketplace);
